import React, { useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import Loader from "../../components/Loader";
import SearchForm from "./components/SearchForm";
import CurrentSong from "./components/CurrentSong";
import SongGrid from "./components/SongGrid";
import SongList from "./components/SongList";

//Material resourcess
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import GridViewIcon from "@mui/icons-material/GridView";
import TableRowsIcon from "@mui/icons-material/TableRows";
import QueuedSongs from "./components/QueuedSongs";

const Finder = () => {
  const [currentSong, setCurrentSong] = useState(null);
  const [currentQueue, setCurrentQueue] = useState(null);
  const [resultList, setResultList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [meta, setMeta] = useState({
    hasPrev: false,
    hasNext: false,
    total: 0,
  });
  const [persistData, setPersistData] = useState(null);
  const [selectedView, setSelectedView] = useState("grid");

  const [clearFlag, setClearFlag] = useState(false);

// --- 1. DEDICATED QUEUE REFRESH FUNCTION (MODIFIED) ---
const getQueue = useCallback(async () => {
    console.log("Finder: getQueue started (triggered by SongGrid or mount)."); // <-- LOG 5
    
    // ... (rest of the code for getQueue)
    
  const response = await api.getQueue();
  
  if (response.success && response.data) {
   console.log("Finder: getQueue API success. New queue data:", response.data); // <-- LOG 6
   
   if (JSON.stringify(currentQueue) !== JSON.stringify(response.data)) {
    setCurrentQueue(response.data);
    console.log("Finder: currentQueue state updated."); // <-- LOG 7
   }
      
      // Clear the search results list
      setResultList(null); 
      console.log("Finder: Cleared resultList state."); // <-- LOG 8
      
  } else {
   console.warn("Finder: getQueue API failed or returned empty data.", response); // <-- LOG 9
   setCurrentQueue([]); 
   setResultList(null); 
   console.log("Finder: Cleared queue and resultList on API failure."); // <-- LOG 10
  }
  setLoading(false);
}, [currentQueue]);

  // --- Initial Load ---
  useEffect(() => {
    getCurrentSong();
    getQueue(); // Call dedicated function on initial load
  }, [getQueue]);

  // --- Interval Refresh (Only Current Song) ---
  useEffect(() => {
    const intervalId = setInterval(() => {
      getCurrentSong();
      // We rely on getCurrentSong to update the queue if playback advances
    }, 10000);

    return () => clearInterval(intervalId);
  });

  const handleSubmit = async (data) => {
    const searchData = {
      ...data,
      page: 1,
      rowsPerPage: rowsPerPage,
    };
    setPage(1);
    setPersistData(searchData);
    search(searchData);
  };

  const search = async (data) => {
    setLoading(true);
    setResultList(null);
    const response = await api.search(JSON.stringify(data));
    if (response.success) {
      const { tracks, hasPrev, hasNext, total } = response.data;
      setMeta({ hasNext, hasPrev, total });
      if (tracks.length > 0) {
        const parsedTracks = [];
        tracks.map((track) => parsedTracks.push({ ...track, added: false }));
        setResultList(parsedTracks);
      }
    }
    setLoading(false);
  };

  console.log(currentQueue)

  // --- 2. MODIFIED getCurrentSong (For Playback Updates) ---
  const getCurrentSong = async () => {
    const songResponse = await api.getCurrentSong();
    const queueResponse = await api.getQueue(); // Fetch both to check for playback changes
    
    // Check for current song change (playback advance)
    if (songResponse.success) {
      if (!currentSong || currentSong.id !== songResponse.data.id) {
        setCurrentSong({ ...songResponse.data });
        
        // If the song changed, the queue state must also be updated
        if(queueResponse.success && queueResponse.data) {
          setCurrentQueue(queueResponse.data);
        } else {
          setCurrentQueue([]);
        }
      }
    } else {
      // If current song request fails, we still check queue for changes
      if (queueResponse.success && queueResponse.data && JSON.stringify(currentQueue) !== JSON.stringify(queueResponse.data)) {
        setCurrentQueue(queueResponse.data);
      }
    }
    setLoading(false);
  };


  const goToPage = (page) => {
    console.log(page);
    setPage(page);
    const data = { ...persistData, page: page };
    search(data);
  };

  const handleView = (event) => {
    setSelectedView(event.target.value);
  };
  console.log(selectedView);

  return (
    <>
      <div className="container d-flex flex-column align-items-center col-12">
        <SearchForm
          handleSubmit={handleSubmit}
          onChangeView={setClearFlag}
          changeFlag={clearFlag}
        />
        {loading && (
          <div className="pt-4 mt-4 d-flex justify-content-center">
            <Loader />
          </div>
        )}
        <div className="d-flex row col-12 mt-4">
          {!!currentSong &&
            (!resultList || resultList.length <= 0) &&
            !loading && (
              <CurrentSong
                className={`col-12 ${ currentQueue?.length > 0 ? 'col-md-6' : ""}`}
                currentSong={currentSong}
                clearFlag={clearFlag}
              />
            )}
          {currentQueue?.length > 0 &&
            (!resultList || resultList.length <= 0) &&
            !loading && (
              <QueuedSongs
                className="col-12 col-md-6"
                queue={currentQueue}
              />
            )}
        </div>
        {!!resultList && (
          <>
            <div className="row col-2">
              {/* <div class="btn-group btn-group-toggle" data-toggle="buttons">...</div> */}
            </div>
            {selectedView === "grid" && (
              <SongGrid 
                resultList={resultList} 
                clearFlag={clearFlag} 
                onQueueUpdate={getQueue} // <--- PASSING THE REFRESH CALLBACK
              />
            )}
            {selectedView === "list" && (
              <SongList 
                className="col-10" 
                resultList={resultList} 
                clearFlag={clearFlag} 
                title="Results" 
                onQueueUpdate={getQueue} // <--- PASSING THE REFRESH CALLBACK (for consistency)
              />
            )}
            <hr className="color-primary" />
            <div className="d-flex justify-content-evenly col-12 my-4 pb-4">
              <button
                className="btn btn-outline-primary"
                style={{ borderRadius: "50%", padding: "0.75rem" }}
                disabled={!meta.hasPrev}
                onClick={() => goToPage(page - 1)}
              >
                <ArrowBackIosNewIcon />
              </button>
              <h4 className="text-primary mb-0 align-self-center">{page}</h4>
              <button
                className="btn btn-outline-primary"
                style={{ borderRadius: "50%", padding: "0.75rem" }}
                disabled={!meta.hasNext}
                onClick={() => goToPage(page + 1)}
              >
                <ArrowForwardIosIcon />
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Finder;